export default __webpack_public_path__ + "assets/6.1ce47ebe.png";